export const HAULIERS = {
  DPMP: 'dpmp',
  NITRA: 'nitra',
  TRENCIN: 'trencin',
  RUZOMBEROK: 'ruzomberok',
  DPB: 'dpb',
  POLAND: 'poland',
};
